import React, { useCallback, useRef } from 'react';
import debounce from 'lodash/debounce';
import "./Button.scss";

interface ButtonType {
  outline?: boolean;
  success?: boolean;
  text?: string;
  type?: any;
  id?: any;
  disabled?: any;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  debounceDelay?: number;
}

export default function Button({
  outline,
  success,
  text,
  onClick,
  type,
  id,
  disabled,
  debounceDelay = 300
}: ButtonType) {
  const isProcessing = useRef(false);

  // Debounce the onClick using lodash's debounce
  const debouncedClick = useCallback(
    debounce((event: React.MouseEvent<HTMLElement>) => {
      if (onClick && !isProcessing.current) {
        isProcessing.current = true;
        onClick(event);
        setTimeout(() => {
          isProcessing.current = false;
        }, debounceDelay);
      }
    }, debounceDelay),
    [onClick, debounceDelay]
  );

  return (
    <button
      className={`${disabled ? "disable" : outline ? "outline" : success ? "success" : "primary"} button-common `}
      onClick={debouncedClick}
      type={type}
      disabled={disabled}
      id={id}
    >
      {text}
    </button>
  );
}
